// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1dAM9","largestCol":"styles_largestCol__2pXmR","smallestCol":"styles_smallestCol__3phvJ"};